/**
 * App shell + client routing. Two lazy top-level chunks:
 *
 *   /live/:deckId             → guest co-presenter (no sign-in; own chunk)
 *   everything else           → AuthedApp (Google AuthGate + library/author)
 *
 *   /                         → deck library (list + upload)
 *   /deck/:deckId             → authoring view (slide 1)
 *   /deck/:deckId/:slide      → authoring view at a 1-based slide number
 *
 * The URL is the single source of truth for "where am I", so a reload restores
 * the exact deck + slide instead of dropping back to the library (FEATURE_PARITY
 * F10). This stays a thin client — react-router-dom only, no data layer changes.
 *
 * Code-splitting invariant: this module must stay free of static imports of
 * firebase.ts, pdfjs, or any authoring component — the /live guest chunk is the
 * most latency-sensitive load (cold click on an invite link), and anything
 * imported here ships to it.
 */
import { lazy, Suspense } from "react";
import { Route, Routes } from "react-router-dom";

const CoPresenterRoute = lazy(() => import("./components/CoPresenterRoute"));
const AuthedApp = lazy(() => import("./AuthedApp"));

export default function App() {
  return (
    <Suspense fallback={null}>
      <Routes>
        {/*
         * Co-presenting join link (D5/D23): a control-only co-pilot. Deliberately
         * OUTSIDE the Google AuthGate — anyone with the link can join with no
         * sign-in and no deck membership; CoPresenterRoute manages its own auth
         * (uses the current user if signed in, else signs in anonymously) and reads
         * deck content through the token-authorized getLiveDeck callable.
         */}
        <Route path="/live/:deckId" element={<CoPresenterRoute />} />
        <Route path="*" element={<AuthedApp />} />
      </Routes>
    </Suspense>
  );
}
